module.exports = __webpack_public_path__ + "img/苏老师-1.f27f0a03.png";